import React from 'react'
import History from './history'
import Contactfooter from './contactfooter'
import { Helmet } from 'react-helmet'

const About = () => {

// console.log("about-page-render")

  return (
    <>
    <div className="">
    <Helmet>
        <title>About</title>
        <meta
          name="description"
          content="Krisoft provides top-notch Android development services, creating innovative and user-friendly mobile applications."
        />
        <meta
          name="keywords"
          content="Android development, mobile apps, Krisoft, app development, Android solutions"
        />
      </Helmet>
        <History/>
        <Contactfooter/>
    </div>
    </>
  )
}

export default About
